import { Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import DateLabel from "../../components/DateLabel";

const validDate = value => typeof value === "string" && /^\d{4}-\d{2}-\d{2}T/.test(value) && Number.isFinite(Date.parse(value));

// Nur belegte Zeitpunkte und bekannte Fehlertexte ausgeben, niemals den Rohtext eines Upstreamfehlers.
export default function ReadModelEvidence({ metadata, fallbackReason }) {
  const { t, i18n } = useTranslation("freigabe");
  if (!metadata) return null;
  const updatedAt = ["ready", "stale"].includes(metadata.state) && validDate(metadata.updatedAt) ? metadata.updatedAt : null;
  const error = metadata.error && typeof metadata.error.code === "string" ? metadata.error : null;
  const errorAt = error && validDate(error.at) ? error.at : null;
  const key = error ? `stageBranches.errors.${error.code}` : null;
  const translated = key && i18n.exists(key, { ns: "freigabe" }) ? t(key) : null;
  const reason = translated && !/\{\{.*?\}\}/.test(translated) ? translated : fallbackReason || t("stageBranches.readModel.refreshFailed");
  if (!updatedAt && !error) return null;
  return <Stack spacing={0.5} sx={{ mt: 1, overflowWrap: "anywhere" }}>
    {updatedAt && <Typography variant="body2" component="div">{t("stageBranches.readModel.updatedAt")} <DateLabel value={updatedAt}/></Typography>}
    {error && <Typography variant="body2" component="div">{reason}</Typography>}
    {errorAt && <Typography variant="body2" component="div">{t("stageBranches.readModel.failedAt")} <DateLabel value={errorAt}/></Typography>}
  </Stack>;
}
